import Predikat from "../../../../../components/categories/siakad/lms/data_ekskul/subpage/predikat/Home";
export default function Home() {
  
  return (
    <Predikat />
  );
}
